import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsItemsTree";

export const messages = defineMessages({
  slidesGroup: {
    id: `${PREFIX}.slidesGroup`,
    defaultMessage: "Slides",
  },
  bulkExportGroup: {
    id: `${PREFIX}.bulkExportGroup`,
    defaultMessage: "Bulk export",
  },
  savedBulkExportGroup: {
    id: `${PREFIX}.savedBulkExportGroup`,
    defaultMessage: "Saved bulk export",
  },
});
